module.exports = __webpack_public_path__ + "static/img/LEON-KICKETT.026f9e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LEON-KICKETT.jpg
// module id = m45O
// module chunks = 0